import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {
  Button,
  FileButton,
  Divider,
  Modal,
  Radio,
  Flex,
  Group,
  Text,
  Grid,
  UnstyledButton,
} from "@mantine/core";
import { IconFileUpload } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import entityColor from "@util/entityColor";
import entityIcon from "@util/entityIcon";

export default function AssetUpload({ reqData, onSuccess, library }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  const [open, setOpen] = useState(false);
  const [uploadProps, setUploadProps] = useState({
    text: "",
    library_variety: null,
    variety: null,
    color: "",
  });
  const managerInfo = useSelector((state) => state.manager);

  const libraryAssetButtons = [
    {
      text: t("mixer:contest_singular"),
      library_variety: 1,
      variety: 5,
      color: entityColor.contest,
      icon: entityIcon.contest(24),
    },
    {
      text: t("mixer:campaign_singular"),
      library_variety: 2,
      variety: 3,
      color: entityColor.campaign,
      icon: entityIcon.campaign(24),
    },
    {
      text: t("mixer:effort_singular"),
      library_variety: 3,
      variety: 2,
      color: entityColor.effort,
      icon: entityIcon.effort(24),
    },
    {
      text: t("common:general"),
      library_variety: 4,
      variety: 10,
      color: entityColor.general,
      icon: entityIcon.general(24),
    },
    {
      text: t("mixer:trouble_ticket_singular"),
      library_variety: 5,
      variety: 7,
      color: entityColor.ticket,
      icon: entityIcon.ticket(24),
    },
    {
      text: t("mixer:email_template_singular"),
      library_variety: 6,
      variety: 13,
      icon: entityIcon.send(24),
      color: "green",
      // color: entityColor.ticket,
      // icon: entityIcon.ticket(),
    },
  ].map((m, i) => ({
    ...m,
    key: i,
  }));

  useEffect(() => {
    if (!open)
      setUploadProps({
        text: "",
        library_variety: null,
        variety: null,
        color: "",
      });
  }, [open]);

  function onUpload(file, variety = null) {
    const formData = new FormData();
    formData.append("tempfile", file);

    if (library && uploadProps.library_variety) {
      formData.append("library_variety", uploadProps.library_variety);
      formData.append("variety", uploadProps.variety);
      // formData.append(
      //   "variety",
      //   assetVarieties[uploadProps.library_variety - 1]
      // );
    }

    if (!library && reqData.contest_id) {
      formData.append("variety", 5);
    }
    if (!library && reqData.campaign_id) {
      formData.append("variety", 3);
    }
    if (!library && reqData.campaign_effort_id) {
      formData.append("variety", 2);
    }
    if (!library && reqData.location_id) {
      formData.append("variety", 8);
    }
    if (!library && reqData.organization_id) {
      formData.append("variety", 12);
    }
    if (!library && reqData.loot_item_id) {
      formData.append("variety", 11);
    }

    if (library && !uploadProps.library_variety) return;

    Object.keys(reqData).forEach((k) => formData.append(k, reqData[k]));

    axios
      .post(`/${library ? "library-" : ""}assets/`, formData)
      .then(({ data }) => {
        toast.success("Uploaded!");
        setShow(false);
        setOpen(false);
        setUploadProps({
          text: "",
          variety: null,
          color: "",
        });
        onSuccess(data.response[0]);

        setTimeout(() => {
          setShow(true);
        }, 1);
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  if (library) {
    if (!show) return null;

    return (
      <React.Fragment>
        <Button
          color="teal"
          radius="md"
          size="sm"
          onClick={() => setOpen(true)}
          leftSection={<IconFileUpload size={20} />}
        >
          {t("mixer:asset:upload_asset")}
        </Button>
        <Modal
          withCloseButton={false}
          // title="New library asset"
          // size="xl"
          opened={open}
          onClose={() => setOpen(false)}
        >
          <Text fw={600} mb="sm" size="lg" align="center">
            {t("mixer:asset:asset_upload_modal_title")}
          </Text>
          <>
            <Grid>
              {libraryAssetButtons
                .filter((f) =>
                  managerInfo ? ![5].includes(f.library_variety) : true
                )
                .map((b, i) => {
                  const isSelected =
                    uploadProps &&
                    uploadProps.library_variety === b.library_variety;

                  return (
                    <Grid.Col span={6} key={i}>
                      <UnstyledButton
                        onClick={() => setUploadProps(b)}
                        p="md"
                        style={{
                          borderRadius: "var(--mantine-radius-md)",
                          border: isSelected
                            ? `1px solid ${`var(--mantine-color-${uploadProps.color}-7)`}`
                            : "1px solid var(--mantine-color-gray-3)",
                          backgroundColor: isSelected
                            ? `var(--mantine-color-${uploadProps.color}-5)`
                            : "var(--mantine-color-gray-1)",
                          transition: "all 0.2s ease",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            color: isSelected
                              ? "var(--mantine-color-gray-0)"
                              : "var(--mantine-color-dark-5)",
                          }}
                        >
                          <Flex
                            direction="column"
                            align="center"
                            justify="center"
                            gap={1}
                          >
                            <div
                              style={{
                                color: isSelected
                                  ? "var(--mantine-color-gray-0)"
                                  : "var(--mantine-color-dark-5)",
                              }}
                            >
                              {b.icon}
                            </div>
                            <Text
                              size="sm"
                              fw={600}
                              style={{
                                color: isSelected
                                  ? "var(--mantine-color-gray-0)"
                                  : "var(--mantine-color-dark-5)",
                              }}
                            >
                              {b.text}
                            </Text>
                          </Flex>
                        </div>
                      </UnstyledButton>
                    </Grid.Col>
                  );
                })}
            </Grid>
            {/* {libraryAssetButtons
              .filter((f) =>
                managerInfo ? ![5].includes(f.library_variety) : true
              )
              .map((b, i) => (
                <Radio
                  key={i}
                  size="md"
                  name="libvariety"
                  checked={
                    uploadProps &&
                    uploadProps.library_variety === b.library_variety
                  }
                  label={b.text}
                  onChange={() => setUploadProps(b)}
                  mb={i !== libraryAssetButtons.length - 1 ? "xs" : ""}
                />
              ))} */}
          </>
          {/* <Group mt="xs" mb="xs">
            {libraryAssetButtons.map((b, i) => (
              <Button
                variant={
                  uploadProps &&
                  uploadProps.library_variety === b.library_variety
                    ? "filled"
                    : "outline"
                }
                onClick={() => setUploadProps(b)}
                color={b.color}
                size="xs"
                key={i}
              >
                {b.text}
              </Button>
            ))}
          </Group> */}
          <Divider mt="lg" mb="lg" />
          <FileButton
            accept={library ? "image/*,.pdf" : "image/*"}
            onChange={(e) => onUpload(e, uploadProps.variety)}
          >
            {(props) => (
              <Button
                {...props}
                fullWidth
                size="md"
                color={uploadProps.color ? uploadProps.color : "green"}
                leftSection={<IconFileUpload size={20} />}
                disabled={!uploadProps.library_variety}
              >
                {t("mixer:asset:upload_asset")}
              </Button>
            )}
          </FileButton>
        </Modal>
      </React.Fragment>
    );
  }

  return (
    <FileButton accept={"image/*"} onChange={(e) => onUpload(e)}>
      {(props) => (
        <Button
          {...props}
          color="green"
          leftSection={<IconFileUpload />}
          size="xs"
          radius="xl"
        >
          {t("common:upload")}
        </Button>
      )}
    </FileButton>
  );
}
